import { ApiError } from '@glomopay/utils';

export const isRetryableApiError = (error: unknown): boolean => {
  const code = error instanceof ApiError ? error.statusCode : undefined;
  return code == null || code >= 500;
};
